export const GUEST_NICKNAME_MAX_LENGTH = 20;

const GUEST_ADJECTIVES = [
  "푸른",
  "초록",
  "붉은",
  "밝은",
  "느긋한",
  "빠른",
] as const;

const GUEST_NOUNS = [
  "기사",
  "항해사",
  "탐험가",
  "연금술사",
  "전략가",
  "마법사",
] as const;

const GUEST_NICKNAME_PATTERN = /^[\p{Script=Hangul}A-Za-z0-9_-]+$/u;
const GUEST_NICKNAME_WHITESPACE_PATTERN = /\s/u;

function countCharacters(value: string): number {
  return Array.from(value).length;
}

function pickRandom<T>(values: readonly T[]): T {
  return values[Math.floor(Math.random() * values.length)]!;
}

export function normalizeGuestNickname(value: string): string {
  return value.trim();
}

export function getGuestNicknameLength(value: string): number {
  return countCharacters(value);
}

export function validateGuestNickname(value: string): string | null {
  const nickname = normalizeGuestNickname(value);
  const length = countCharacters(value);

  if (countCharacters(nickname) < 1) {
    return "닉네임을 입력해주세요.";
  }
  if (length > GUEST_NICKNAME_MAX_LENGTH) {
    return "닉네임은 20자 이하로 입력해주세요.";
  }
  if (GUEST_NICKNAME_WHITESPACE_PATTERN.test(value)) {
    return "닉네임에는 공백을 사용할 수 없습니다.";
  }
  if (!GUEST_NICKNAME_PATTERN.test(value)) {
    return "닉네임은 한글, 영문, 숫자, -, _만 사용할 수 있습니다.";
  }
  return null;
}

export function generateGuestNickname(): string {
  const suffix = Math.floor(Math.random() * 100);
  return `${pickRandom(GUEST_ADJECTIVES)}${pickRandom(GUEST_NOUNS)}-${suffix}`;
}
